import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const CodeTabs = makeShortcode("CodeTabs");
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><dl parentName="p"><dt parentName="dl"><inlineCode parentName="dt">{`spans`}</inlineCode></dt><dd parentName="dl">{``}<em parentName="dd">{`Recommended`}</em>{`. A list of `}<a parentName="dd" {...{
            "href": "/sdk/event-payloads/span/"
          }}>{`Spans`}</a>{`.`}</dd></dl></p>
    <div {...{
      "className": "code-tabs-wrapper"
    }}><CodeTabs mdxType="CodeTabs"><CodeBlock language="json" title="" filename="" mdxType="CodeBlock"><div parentName="div" {...{
            "className": "gatsby-highlight",
            "data-language": "json"
          }}><pre parentName="div" {...{
              "className": "language-json"
            }}><code parentName="pre" {...{
                "className": "language-json"
              }}><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"spans"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`[`}</span>{`
    `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"start_timestamp"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token number"
                }}>{`1588601261.481961`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"description"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"GET /sockjs-node/info"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"tags"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
        `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"http.status_code"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"200"`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"timestamp"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token number"
                }}>{`1588601261.488901`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"parent_span_id"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"b0e6f15b45c36b12"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"trace_id"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"1e57b752bc6e4544bbaa246cd1d05dee"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"op"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"http"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"data"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
        `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"url"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"http://localhost:8080/sockjs-node/info?t=1588601703755"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
        `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"status_code"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token number"
                }}>{`200`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
        `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"type"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"xhr"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
        `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"method"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"GET"`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"span_id"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"b01b9f6349558cd1"`}</span>{`
    `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
    `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"start_timestamp"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token number"
                }}>{`1588601261.535386`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"description"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"Vue <App>"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"timestamp"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token number"
                }}>{`1588601261.544196`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"parent_span_id"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"9312d0d18bf51736"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"trace_id"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"1e57b752bc6e4544bbaa246cd1d05dee"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"op"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"update"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"span_id"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"b980d4dec78d7344"`}</span>{`
    `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`]`}</span>{`
`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span></code></pre></div></CodeBlock></CodeTabs></div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      